<template>
    <div class="vx-col md:w-full sm:w-auto text-center" >
        <ul class="display-flex justify-content-center ">
            <li>

                <vx-tooltip v-if="params.data.status == 0 && isPermissionUpdate()" :text="$t('statusActive.approve')" position="top">
                    <feather-icon icon="CheckIcon" class="mr-4 text-primary"
                                  svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                                  @click="confirmAcceptLeave"/>
                </vx-tooltip>

                <vx-tooltip v-if="params.data.status == 0 && isPermissionUpdate()" :text="$t('statusActive.decline')" position="top">
                    <feather-icon icon="XIcon" class="mr-4 text-danger"
                                  svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                                  @click="confirmRejectLeave"/>
                </vx-tooltip>

                <vx-tooltip :text="$t('button.edit')" position="top">
                    <feather-icon icon="EyeIcon" class="text-primary"
                                  svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                                  @click="editRecord"/>
                </vx-tooltip>
            </li>
        </ul>
        <vs-popup class="holamundo"  title="Thông tin phòng ban" :active.sync="openOvertimeDetails" v-if="openOvertimeDetails" id="details-overtime">
            <OvertimeInfomation :overtimeId="params.data.id" :branchId="params.data.organizationBranchId"></OvertimeInfomation>
        </vs-popup>
    </div>
</template>

<script>

import {isAPI } from "../../../../store/permission";
import {constAPI} from "../../../../store/constant";
import OvertimeInfomation from "../OvertimeInfomation";

export default {
    name: 'CellRendererActions',
    components: {
        OvertimeInfomation
    },
    data() {
        return{
            openOvertimeDetails: false,
        }
    },
    methods: {
        isPermissionUpdate() {
            return isAPI(this, constAPI.over_time_edit);
        },
        editRecord() {
            // this.$router.push(`/user/over-time?branch_id=${this.params.data.organizationBranchId}&id=${this.params.data.id}`).catch(() => {
            // })
            this.openOvertimeDetails = true;
        },
        confirmAcceptLeave() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận duyệt`,
                text: `Bạn có chắc là muốn duyệt đơn làm thêm của nhân viên "${this.params.data.employeeFullName}" không ? `,
                accept: this.acceptLeave,
                acceptText: "Xác nhận",
                cancelText: "Huỷ"
            })
        },
        acceptLeave() {
            this.$vs.loading();
            const payload = this.params.data;
            payload.status = 1;
            this.$crm.post('/over-time/update', payload).then(() => {
                this.$vs.loading.close();
                this.showUpdateSuccess(true);
                this.$store.commit('UPDATE_OVERTIME', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        confirmRejectLeave() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận từ chối`,
                text: `Bạn có chắc là muốn từ chối đơn làm thêm của nhân viên "${this.params.data.employeeFullName}" không ? `,
                accept: this.acceptCancelLeave,
                acceptText: "Xác nhận",
                cancelText: "Huỷ"
            })
        },
        acceptCancelLeave() {
            this.$vs.loading();
            const payload = this.params.data;
            payload.status = 2;
            this.$crm.post('/over-time/update', payload).then(() => {
                this.$vs.loading.close();
                this.showUpdateSuccess(false);
                this.$store.commit('UPDATE_OVERTIME', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        showUpdateSuccess(check) {
            this.$vs.notify({
                color: 'success',
                text: check ? 'Duyệt ca làm thêm thành công' : 'Từ chối ca làm thêm thành công',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
            })
        }
    },

    mounted() {
        this.$eventBus.$on('update-overtime-success', () => {
            this.openOvertimeDetails = false;
            this.$store.commit('UPDATE_OVERTIME', true)
        })
    }
}
</script>

<style lang="scss">
#details-overtime {
    .vs-popup {
        width: 1400px !important;
    }
}
</style>
